export const subjectsAndSub = new Map<string, string[]>();

subjectsAndSub.set('Lettres et arts', ['Lettres et littérature',
  'Langue française, langues et linguistique',
  'Arts et histoire de l\'art',
  'Audio-visuel, cinéma et jeu vidéo',
  'Musique']);

subjectsAndSub.set('Sciences', ['Mathématiques',
  'Physique-chimie et astronomie',
  'Biologie, médecine et paléontologie',
  'Technologie et informatique']);

subjectsAndSub.set('Sciences sociales', ['Histoire',
  'Géographie et géopolitique',
  'Société et éducation civique',
  'Philosophie et esprit critique',
  'Economie',
  'Psychologie']);

subjectsAndSub.set('Divers', ['Sport',
  'Culture générale',
  'Méthodologie',
  'YouTube pour les plus jeunes']);

export const subjects = [
  'Lettres et littérature',
  'Langue française, langues et linguistique',
  'Histoire',
  'Géographie et géopolitique',
  'Société et éducation civique',
  'Philosophie et esprit critique',
  'Economie',
  'Mathématiques',
  'Physique-chimie et astronomie',
  'Biologie, médecine et paléontologie',
  'Technologie et informatique',
  'Arts et histoire de l\'art',
  'Musique',
  'Audio-visuel, cinéma et jeu vidéo',
  'Sport',
  'Culture générale',
  'Psychologie',
  'Méthodologie',
  'YouTube pour les plus jeunes',
];
